import React, { Children } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { Divider, TextField } from '@biq/apex-ui';
import {
    LabelAndValueComponent,
    updateUserWalletStyles as labelAndValueStyles,
} from 'pages/wallets-and-groups/components/create-or-edit-user-wallet/user-wallet-from-helper';
import { pipelineFormStyles as styles } from 'pages/pipelines/CreateOrUpdatePipeline/components/pipeline-form-helper';
import {
    stepDetailsFormStyles,
    UpdateStepDetailsFormDataProps,
} from './step-details-form-helper';

export const StepDetailsForm = ({
    control,
    errors,
    stepDetailsFormValues,
    handleUnsavedChanges,
}: UpdateStepDetailsFormDataProps): React.JSX.Element => {
    return (
        <Grid
            sx={{
                ...styles.mainContainer,
                mx: 0,
            }}
        >
            <Box sx={styles.fieldGroup}>
                <Controller
                    name='name'
                    control={control}
                    render={({ field }): React.JSX.Element => (
                        <TextField
                            {...field}
                            variant='outlined'
                            label='Name'
                            value={field.value ?? stepDetailsFormValues?.name}
                            onChange={(event): void => {
                                field.onChange(event);
                                handleUnsavedChanges?.();
                            }}
                            onBlur={(value): void => {
                                field.onChange(value.target.value.trim());
                            }}
                            required
                            error={!!errors?.name}
                            errorText={errors?.name?.message ?? ''}
                        />
                    )}
                />
            </Box>

            <Box sx={styles.fieldGroup}>
                <Controller
                    name='description'
                    control={control}
                    render={({ field }): React.JSX.Element => (
                        <TextField
                            {...field}
                            variant='outlined'
                            label='Description'
                            value={
                                field.value ??
                                stepDetailsFormValues?.description
                            }
                            onChange={(event): void => {
                                field.onChange(event);
                                handleUnsavedChanges?.();
                            }}
                            onBlur={(value): void => {
                                field.onChange(value.target.value.trim());
                            }}
                            minRows={4}
                            multiline
                            error={!!errors?.description}
                            errorText={errors?.description?.message ?? ''}
                        />
                    )}
                />
            </Box>

            <Box sx={{ ...styles.fieldGroup, mt: 0 }}>
                <LabelAndValueComponent
                    label='Type'
                    value={stepDetailsFormValues?.type ?? ''}
                />
            </Box>

            <Divider
                sx={{
                    ...stepDetailsFormStyles.dividerStyles,
                    ...styles.fieldGroup,
                    mt: 3,
                }}
            />

            <Box sx={{ ...styles.fieldGroup }}>
                <Typography
                    sx={stepDetailsFormStyles.headingTextStyles}
                    variant='h3'
                >
                    Usage Details
                </Typography>
            </Box>

            <Box sx={{ ...styles.fieldGroup, mt: 0 }}>
                <LabelAndValueComponent
                    label='In Pipelines (#)'
                    value={
                        stepDetailsFormValues?.pipelineInfo?.length.toString() ??
                        '0'
                    }
                />
            </Box>

            <Box sx={{ ...styles.fieldGroup, mt: 0 }}>
                <Grid sx={labelAndValueStyles.labelAndValueContainer}>
                    <Grid>
                        <Typography sx={labelAndValueStyles.labelStyles}>
                            Pipelines Using This Step
                        </Typography>
                    </Grid>
                    <Grid>
                        {stepDetailsFormValues?.pipelineInfo.length ? (
                            Children.toArray(
                                stepDetailsFormValues?.pipelineInfo.map(
                                    (pipeline) => (
                                        <Typography
                                            sx={labelAndValueStyles.valueStyles}
                                        >
                                            {pipeline.name}
                                        </Typography>
                                    )
                                )
                            )
                        ) : (
                            <Typography sx={labelAndValueStyles.valueStyles}>
                                None
                            </Typography>
                        )}
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};
